var map = {
	"./Collections-Active.png": 42,
	"./Home-Active.png": 43,
	"./Interest-Active.png": 44,
	"./Mood-Active.png": 45,
	"./Profile-Active.png": 46,
	"./Spread-Active.png": 47,
	"./Trackers-Active.png": 48
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85;